import React, { useState } from 'react'
import PropTypes from 'prop-types'
import {
    Fab,
    Drawer,
    IconButton,
    Typography,
    Box,
    Radio,
    FormControlLabel,
    FormControl,
    RadioGroup,
} from '@mui/material'
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView'
import { TreeItem } from '@mui/x-tree-view'
import LayersIcon from '@mui/icons-material/Layers'
import CloseIcon from '@mui/icons-material/Close'

/*
Recibe una definicion de menu arbol de la forma

{categories : [{name,label, menus: {value,handler,name,value}},...]}

*/

export default function MenuGeoVisualizador({
    menu,
    selectedMenu,
    handleChange,
    mcel,
}) {
    const [drawerOpen, setDrawerOpen] = useState(false)

    const toggleDrawer = (open) => (event) => {
        if (
            event.type === 'keydown' &&
            (event.key === 'Tab' || event.key === 'Shift')
        ) {
            return
        }
        setDrawerOpen(open)
    }
    let menuItems = []
    menu.categories.forEach((category) => {
        let menuItemsTreeNode = []
        category.menus.forEach((menuItem) => {
            menuItemsTreeNode.push()
            const element = (
                <FormControlLabel
                    key={menuItem.value}
                    checked={selectedMenu === menuItem.value}
                    value={menuItem.value}
                    label={menuItem.name}
                    sx={{
                        color: '#fff',
                        '&.Mui-checked': { color: '#fff' },
                        '&.Mui-unchecked': { color: '#fff' },
                    }}
                    control={<Radio />}
                />
            )
            menuItemsTreeNode.push(element)
        })
        menuItems.push(
            <TreeItem
                key={category.name}
                itemId={category.name}
                label={category.label}
                sx={{ color: '#fff' }}
            >
                <FormControl>
                    <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        name="radio-buttons-group"
                        onChange={handleChange}
                    >
                        {menuItemsTreeNode}
                    </RadioGroup>
                </FormControl>
            </TreeItem>
        )
    })

    let sxObj = {
        position: 'absolute',
        top: 16,
        backgroundColor: '#004b87', // Azul oscuro
        '&:hover': {
            backgroundColor: '#003366', // Azul más oscuro al hacer hover
        },
    }

    if (!mcel) {
        sxObj.left = 16
    } else {
        sxObj.right = 16
    }

    return (
        <>
            <Fab
                color="primary"
                aria-label="layers"
                onClick={toggleDrawer(true)}
                sx={sxObj}
            >
                <LayersIcon />
            </Fab>

            <Drawer
                anchor={mcel ? 'right' : 'left'}
                open={drawerOpen}
                onClose={toggleDrawer(false)}
                sx={{ overflowY: 'none' }}
            >
                <Box
                    sx={{
                        width: 320,
                        height: '100%',
                        bgcolor: '#004b87', // Azul oscuro
                        color: '#fff', // Texto en blanco
                    }}
                >
                    {/* Header con logo y título */}
                    <Box
                        sx={{
                            p: 2,
                            borderBottom: '1px solid #ccc',
                            textAlign: 'center',
                        }}
                    >
                        {/* Logo de InUMet */}
                        <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <img
                                src="https://www.inumet.gub.uy/themes/custom/inumet/images/logo-inumet.png"
                                alt="InUMet Logo"
                                style={{ height: 40 }}
                            />
                            <IconButton
                                onClick={toggleDrawer(false)}
                                sx={{ color: '#fff' }}
                            >
                                <CloseIcon />
                            </IconButton>
                        </Box>
                        {/* Título del portal */}
                        <Box display="flex" alignItems="left" sx={{ ml: 2 }}>
                            <Typography
                                variant="h4"
                                sx={{
                                    fontFamily: "'Passion One', sans-serif",
                                    mt: 2,
                                    color: '#fff', // Color del texto en blanco
                                    textAlign: 'center',
                                }}
                            >
                                PORTAL AGRO
                            </Typography>
                        </Box>
                    </Box>
                    <SimpleTreeView
                        aria-label="layer options"
                        sx={{
                            flexGrow: 1,
                            overflowY: 'auto',
                            marginTop: '20px',
                        }}
                    >
                        {menuItems}
                    </SimpleTreeView>
                </Box>
            </Drawer>
        </>
    )
}

MenuGeoVisualizador.propTypes = {
    menu: PropTypes.object,
    selectedMenu: PropTypes.string,
    mcel: PropTypes.bool,
    handleChange: PropTypes.func,
}
